import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "aside-logo flex-column-auto",
  id: "kt_aside_logo"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "text-uppercase text-white"
}
const _hoisted_4 = {
  id: "kt_aside_toggle",
  class: "btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle",
  "data-kt-toggle": "true",
  "data-kt-toggle-state": "active",
  "data-kt-toggle-target": "body",
  "data-kt-toggle-name": "aside-minimize"
}
const _hoisted_5 = { class: "svg-icon svg-icon-1 rotate-180" }
const _hoisted_6 = { class: "aside-menu flex-column-fluid" }
const _hoisted_7 = {
  class: "aside-footer flex-column-auto pt-5 pb-7 px-5 d-none",
  id: "kt_aside_footer"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "btn-label" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon btn-icon svg-icon-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_aside",
    class: _normalizeClass(["aside aside-hoverable", [
      _ctx.asideTheme === 'light' && 'aside-light',
      _ctx.asideTheme === 'dark' && 'aside-dark',
    ]]),
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "aside",
    "data-kt-drawer-activate": "{default: true, lg: false}",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.company?.avatars?.navbar)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            alt: "Logo",
            src: `${_ctx.repo}/${_ctx.company?.avatars?.navbar}`,
            class: "h-45px logo"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_ctx.company?.alias), 1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr080.svg" })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_KTMenu)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("a", {
        class: "btn btn-custom btn-primary w-100",
        href: _ctx.terms,
        target: "_blank"
      }, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t("terms")), 1),
        _hoisted_10
      ], 8, _hoisted_8)
    ])
  ], 2))
}